import { PAGE_FLOW, PROPOSAL_PHASE_TYPE } from '../../../../constants/proposalTypes'
import ProposalConsent from '../ProposalConsent/ProposalConsent'
import ProposalStatusBarBlock from '../ProposalStatusBar/ProposalStatusBarBlock'

const ProposalFormHead = props => {
  const {
    proposalType,
    pageFlow: { isCurrent },
    match: { params: { phase } }
  } = props

  switch (phase) {
    case PROPOSAL_PHASE_TYPE.OVERVIEW: {
      return (
        /** overview 時的提案單狀態那一列 */
        <ProposalStatusBarBlock
          proposalType={proposalType}
        />
      )
    }
    case PROPOSAL_PHASE_TYPE.COMPOSE:
    default: {
      return isCurrent(PAGE_FLOW.CONFIRM)
        ? (
          /** 同意書 */
          <ProposalConsent
            proposalType={proposalType}
          />
        )
        : null
    }
  }
}

export default ProposalFormHead
